module.exports = function(el) {
  el.parentNode && el.parentNode.removeChild(el);
};


// WEBPACK FOOTER //
// ./~/min-dom/lib/remove.js